export type ChartAuthorizationLabel = 'SEA' | 'STA' | 'FEA' | 'FTA' | 'UNMAPPED';

export function authorizationServiceDescription(auth: {
  service_description?: string | null;
  auth_type?: string | null;
  service_code?: string | null;
  focus_service_code?: string | null;
}): string {
  const description = String(auth.service_description || '').trim();
  if (description) return description;
  const type = chartAuthorizationTypeLabel(auth.auth_type);
  const code = String(auth.focus_service_code || auth.service_code || '').trim();
  if (type === 'FTA' || code === '92526') return 'Feeding Therapy';
  if (type === 'STA' || code === '92507') return 'Speech Therapy';
  return 'Speech Therapy';
}

export function chartAuthorizationTypeLabel(authType: string | null | undefined): ChartAuthorizationLabel {
  const type = (authType || '').toUpperCase();
  if (type === 'SEA' || type === 'STA' || type === 'FEA' || type === 'FTA') return type;
  return 'UNMAPPED';
}

export function chartAuthorizationTypeClass(label: ChartAuthorizationLabel): string {
  switch (label) {
    case 'SEA':
      return 'bg-purple-50 text-purple-700 border border-purple-200';
    case 'STA':
      return 'bg-sky-50 text-sky-700 border border-sky-200';
    case 'FEA':
      return 'bg-emerald-50 text-emerald-800 border border-emerald-200';
    case 'FTA':
      return 'bg-amber-50 text-amber-800 border border-amber-200';
    default:
      return 'bg-rose-50 text-rose-800 border border-rose-200';
  }
}

export function currentAuthorizationFlags(authorizations: Array<{ auth_type?: string | null; status?: string | null }>) {
  const current = (type: string) => authorizations.some(auth => auth.auth_type === type && auth.status !== 'EXPIRED');
  return {
    hasSea: current('SEA'),
    hasSta: current('STA'),
    hasFea: current('FEA'),
    hasFta: current('FTA')
  };
}

export function speechAuthorizationStatusText(flags: { hasSea: boolean; hasSta: boolean }): string {
  if (flags.hasSea && flags.hasSta) {
    return 'Concurrent Authorizations: Client has both active SEA evaluation and STA treatment authorizations on file.';
  }
  if (flags.hasSea) {
    return 'Evaluation Authorized Only (SEA): Client may receive initial evaluation (CPT 92523). Ongoing speech treatment sessions (CPT 92507) will be held until an STA authorization is issued.';
  }
  if (flags.hasSta) {
    return 'Treatment Authorized (STA): Client is authorized for ongoing speech therapy treatment sessions (CPT 92507).';
  }
  return 'No current active speech evaluation or treatment authorizations on file.';
}

export function feedingAuthorizationStatusText(flags: { hasFea: boolean; hasFta: boolean }): string {
  if (flags.hasFea && flags.hasFta) {
    return 'Concurrent Feeding Authorizations: Client has both active FEA evaluation and FTA treatment authorizations on file.';
  }
  if (flags.hasFea) {
    return 'Feeding Evaluation Authorized Only (FEA): Client may receive a feeding evaluation (CPT 92610). Ongoing feeding treatment (CPT 92526) will be held until an FTA authorization is issued.';
  }
  if (flags.hasFta) {
    return 'Feeding Treatment Authorized (FTA): Client is authorized for ongoing feeding therapy treatment sessions (CPT 92526).';
  }
  return '';
}
